module.exports = __webpack_public_path__ + "static/media/tr_6_online.be90e95a.png";